import { Chip, Tooltip } from '@mui/material';
import {
  isKnownScale,
  toSimplifiedRating,
  SIMPLIFIED_COLORS,
  SIMPLIFIED_LABELS,
} from '@/api/types/jobEnd.types';
import { RATING_LABELS } from '@/utils/ratingLabels';

interface RatingBadgeChipProps {
  code: string | null;
  labelMode?: 'full' | 'simplified';
  showTooltip?: boolean;
}

export function RatingBadgeChip({
  code,
  labelMode = 'full',
  showTooltip = false,
}: RatingBadgeChipProps) {
  if (code === null || code.trim() === '') {
    return <>-</>;
  }

  const bucket = isKnownScale(code) ? toSimplifiedRating(code) : 'NA';
  const color = SIMPLIFIED_COLORS[bucket];
  const fullLabel = isKnownScale(code) ? RATING_LABELS[code] : code;
  const label = labelMode === 'simplified' ? bucket : fullLabel;

  const chip = <Chip label={label} size="small" color={color} sx={{ minWidth: 50 }} />;

  if (!showTooltip) {
    return chip;
  }

  return <Tooltip title={SIMPLIFIED_LABELS[bucket]}>{chip}</Tooltip>;
}

export default RatingBadgeChip;
